/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const tiptapEditorToolbarStyle = {
  container: {
    alignItems: "center",
    gap: "1rem",
    padding: "0.5rem 1rem",
    borderWidth: 0,
    borderBottomWidth: "0.0625rem",
    borderStyle: "solid",
    borderColor: "grey.400",
  },
};
